// 能力模型（PRD §2）：前端导航渲染与服务端鉴权共用同一份枚举，禁止各自维护。
// 人员/部门来自飞书通讯录；制度角色全部在系统内由 admin 指派（user_roles 表）。

export const CAPABILITIES = [
  "admin", // 系统管理：角色指派、参数配置、窗口管理、用户管理
  "ops", // 制度运营：台账登记、公示发布、复核受理、预算清单、申报归集
  "decide", // 最终确认：A/S 级事项、一事一议、中/重违纪、年度表彰、预算参数确认
  "review", // 业务评议：成果真实性/归属/等级/分配的评议意见
  "verify", // 预算与权益核验：现金发放、福利兑换、个人上限核验
  "dept_head", // 部门评议：部门周期贡献分配、D/C 级确认、20% 自由裁量（指派到具体部门）
  "employee", // 默认能力：申报、查看本人账户、公示页、复核申诉、匿名评价
] as const;

export type Capability = (typeof CAPABILITIES)[number];

export function isCapability(value: string): value is Capability {
  return (CAPABILITIES as readonly string[]).includes(value);
}

/** 能力中文标签（制度角色对应） */
export const CAPABILITY_LABELS: Record<Capability, string> = {
  admin: "系统管理员",
  ops: "制度运营组",
  decide: "决策评议组",
  review: "业务评议组",
  verify: "预算与权益核验组",
  dept_head: "一级部门负责人",
  employee: "全体员工",
};

/**
 * 制度角色 → 能力映射结构。
 * 当前为 1:1，保留数组结构以兼容将来一个制度角色聚合多个能力的调整。
 */
export const ROLE_CAPABILITY_MAP: Record<string, Capability[]> = {
  系统管理员: ["admin"],
  制度运营组: ["ops"],
  决策评议组: ["decide"],
  业务评议组: ["review"],
  预算与权益核验组: ["verify"],
  一级部门负责人: ["dept_head"],
  全体员工: ["employee"],
};

/** 校验用户能力集合是否满足要求。project_lead 不是全局能力，是项目表字段，不在此枚举内。 */
export function hasCapability(owned: readonly Capability[], required: Capability): boolean {
  return owned.includes(required);
}
